import React, { useEffect } from "react";
import { venueService } from "services/venueService";

export default function useHomeFacilities() {
  const [facilites, setFacilites] = React.useState<any[]>([]);

  useEffect(() => {
    (async () => {
      const result = await venueService.getVenueFacilities();

      if (!result) return;

      setFacilites(result);
    })();
  }, []);

  return { facilites };
}
